import type { FC } from "react";

import { useRegisterCommandResults } from "src/components/commandbar/results-context";
import type { CommandResult } from "src/components/commandbar/types";
import { useUser } from "src/contexts/user-context";
import { usePersistedState } from "src/hooks/use-persisted-state";
import { getPersistedKey } from "src/pages/home/components/use-recently-viewed";
import {
  RESOURCE_ICONS,
  getHref,
} from "src/pages/home/agentic/components/recently-viewed-list";
import { useRecentlyViewedNames } from "src/pages/home/agentic/components/recently-viewed-names";
import { rankRecentlyViewed } from "src/pages/home/agentic/components/recently-viewed-rank";
import type { Meta } from "src/pages/home/route-utils";

// Reads the same per-workspace history as the home page's "Recently viewed" list.
export const RecentResultsSource: FC = () => {
  const { workspace } = useUser();
  const marketing = usePersistedState<Meta[]>(
    getPersistedKey(workspace?.id, "marketing"),
    [],
  );
  const activation = usePersistedState<Meta[]>(
    getPersistedKey(workspace?.id, "activation"),
    [],
  );
  const studio = usePersistedState<Meta[]>(
    getPersistedKey(workspace?.id, "studio"),
    [],
  );
  const recents = rankRecentlyViewed(
    marketing.value,
    activation.value,
    studio.value,
  );
  const { resolveName, isLoading, isError, refetchFailed } =
    useRecentlyViewedNames(recents);

  const results = recents.flatMap((meta): CommandResult[] => {
    const name = resolveName(meta);
    return name
      ? [
          {
            id: meta.id,
            type: meta.resource,
            name,
            icon: RESOURCE_ICONS[meta.resource],
            href: getHref(meta),
          },
        ]
      : [];
  });

  useRegisterCommandResults({
    id: "recents",
    results,
    isLoading,
    isError,
    onRetry: refetchFailed,
    zeroQuery: true,
  });

  return null;
};
